/**
 * angular core imports
 */
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
/**
 * library imports
 */
import { DeviceDetectorService } from 'ngx-device-detector';
/**
 * Content visibility constant.
*/
import { CONTENT_VISIBILITY, PRODUCT_TYPE_CONSTANT, SCREEN_NAME } from '../../constants/app.constants';
import { SURVEY_EVENT_NAME } from '../../analytics-event/survey-analytics.constant';
/**
 * service imports
*/
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { AnalyticsEventService } from '../../analytics-event/analytics-event.service';
@Component({
  selector: 'app-survey-feed-card',
  templateUrl: './survey-feed-card.component.html',
  styleUrls: ['./survey-feed-card.component.scss']
})
export class SurveyFeedCardComponent implements OnInit {
  @Input() callingfrom;
  @Input() surveyObj;

  deviceType;
  isShownWebModal = false;
  tncData;
  displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };

  /**
   * Content visibility constant.
   */
  public contentVisibility = CONTENT_VISIBILITY;
  /**
   * screen name constant
   */
  public screenName = SCREEN_NAME;

  constructor(private fcs: FunCollectionService, private dss: DataStorageService, private masterService: MasterserviceService, private router: Router, public multiLangService: MultiLangService, private deviceSer: DeviceDetectorService, public mls: NewLanguageService, private aes : AnalyticsEventService) { }

  ngOnInit(): void {
    if (this.deviceSer.isMobile() == true) {
      this.deviceType = 'mobile';
    } else if (this.deviceSer.isTablet() == true) {
      this.deviceType = 'tablet';
    } else {
      this.deviceType = 'desktop';
    }
  }


    /**
   * Navigate to survey detail
   * @param section 
   * @returns 
   */
  navigateTodetail(section): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');

      return false;
    }
    this.router.navigateByUrl(section);
  }

  /**
   * attempt survey
   */
  attemptSurvey(): void {
    if(this.callingfrom === SCREEN_NAME.GRAND_ROUND){
    this.aes.sendAnalytics(SURVEY_EVENT_NAME.VIEW_DETAILS_CLICK,
      PRODUCT_TYPE_CONSTANT.SURVEY,
      this.surveyObj.product_type_id,
      SCREEN_NAME.GRAND_ROUND);
    }
    if (['not_attempted', 'NOT_ATTEMPTED', 'ongoing', 'ONGOING' ].indexOf(
      this.surveyObj.remark.toLowerCase() ) > -1 ) {
      this.fcs.openUrlInNewTab(this.surveyObj.redirect_url);
    }
  }

  showtnc(): void {
    // console.log(this.surveyObj)
    // this.tncData={safeurl: this.surveyObj.safe_url,display_section:'showtnc'}
    // this.tncData={tnc_url:this.surveyObj.tnc, safeurl: this.surveyObj.safe_url,display_section:'showtnc'}

    this.tncData = { tnc_url: this.surveyObj.tnc, safeurl: this.surveyObj.safe_url, display_section: 'showtnc', display_source: 'survey' };

    this.displayObj.isShow = true;
    this.displayObj.display_section = 'showtnc';
    this.displayObj.data = this.tncData;
    this.masterService.showWebModal.next(this.displayObj);
  }

  /**
   * Product share
   */
  productShare(): void {
    const x = [{ share_url: '', share_contentt: this.surveyObj.share_content, product_type: this.surveyObj.product_type, product_type_id: this.surveyObj.safe_url }];
    this.fcs.productShare(x);
  }


}
